'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

import { SearchBar } from '@/elements/search-bar/search-bar.component';
import { Lecturer } from '@/elements/lecturer/lecturer.component';
import { LecturerCard } from '@/elements/lecturer-card/lecturer-card.component';
import { Container } from './lecturers.elements';

import {
  filterLecturersByEducations,
  filterLecturers,
} from '@/helpers/lecturer-filters.helpers';

const Lecturers = ({
  lecturers: allLecturers,
  educations = [],
  tags: allTags = [],
  primary = false,
  teamMembers,
  type = 'bio',
  searchable = false,
  preserveOrder = false,
}) => {
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState([]);
  const [activeTag, setActiveTag] = useState(null);
  const [lecturers, setLecturers] = useState(allLecturers);

  const handleTagClick = (tag) => {
    setActiveTag(tag);
  };

  useEffect(() => {
    if (!searchable) return;

    const hasActiveFilters = filters.length > 0 || activeTag !== null || search.trim().length > 0;

    const searchFilters =
      search.trim().length > 0 ? [{ id: 'live-search', value: search, type: 'search' }] : [];

    const nonSearchFilters = filters.filter((filter) => filter.type !== 'search');

    const hasEducationFilters = nonSearchFilters.length > 0 || activeTag !== null;

    if (!hasActiveFilters) {
      setLecturers(allLecturers);
      return;
    }

    const baseLecturers = hasEducationFilters
      ? filterLecturersByEducations(allLecturers, educations, nonSearchFilters, activeTag)
      : allLecturers;

    if (search.trim().length === 0) {
      setLecturers(baseLecturers);
      return;
    }

    const filteredLecturers = filterLecturers(baseLecturers, educations, searchFilters);

    setLecturers(filteredLecturers);
  }, [searchable, allLecturers, educations, filters, search, activeTag]);

  return (
    <>
      {searchable && (
        <SearchBar
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          tags={allTags}
          onTagClick={handleTagClick}
          activeTag={activeTag}
          target="lecturers"
        />
      )}
      <Container $type={type}>
        {lecturers
          .filter((object, i, self) => i === self.findIndex((t) => t.id === object.id))
          .sort((a, b) => (preserveOrder ? 0 : a.lastName.localeCompare(b.lastName)))
          .map((lecturer) => (
            <Link
              href={`/predavaci/${lecturer.slug}`}
              key={lecturer.id}
              style={{ display: 'block', width: '100%' }}
            >
              {type === 'bio' ? (
                <Lecturer
                  key={lecturer.id}
                  lecturer={lecturer}
                  primary={primary}
                  teamMember={teamMembers}
                />
              ) : (
                <LecturerCard lecturer={lecturer} />
              )}
            </Link>
          ))}
      </Container>
    </>
  );
};

export { Lecturers };
